module.exports = __webpack_public_path__ + "static/media/flag-icon-white.4c305756.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flag-icon-white.svg
// module id = 1223
// module chunks = 0